import React from "react";

export const MDXComponents = {
  h1: (props: any) => <h1 className="text-lg font-bold mb-4 mt-6" {...props} />,
  h2: (props: any) => (
    <h2 className="text-md font-semibold mb-3 mt-5" {...props} />
  ),
  p: (props: any) => <p className="my-3" {...props} />,
  ol: (props: any) => <ol className="list-decimal pl-6 my-4" {...props} />,
  ul: (props: any) => <ul className="list-disc pl-6 my-4" {...props} />,
  li: (props: any) => <li className="mb-1" {...props} />,
};
